import {
	GET_ACCESS_COMPANIES,
	GET_ACCESS_COMPANIES_ERROR,
	GET_ACCESS_COMPANIES_SUCCESS,
} from '../../constants';

export const getAccessCompaniesReducer = (state, actions) => {
	switch (actions.type) {
		case GET_ACCESS_COMPANIES:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_ACCESS_COMPANIES_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_ACCESS_COMPANIES_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				accessCompanies: actions.payload,
			};
		default:
			return state;
	}
};
